'use client';

import React from 'react';

const DEFAULT_SCROLL_THRESHOLD = 700;

export function useScrollReveal(scrollThreshold: number = DEFAULT_SCROLL_THRESHOLD) {
  const [isVisible, setIsVisible] = React.useState(false);
  const [didDismiss, setDidDismiss] = React.useState(false);

  const handleScroll = React.useCallback(() => {
    const position = window.pageYOffset;
    if (position > scrollThreshold && !isVisible && !didDismiss) {
      setIsVisible(true);
    }
  }, [didDismiss, isVisible, scrollThreshold]);

  const handleOnClose = React.useCallback(() => {
    setIsVisible(false);
    setDidDismiss(true);
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return { handleOnClose, isRevealed: isVisible };
}
